import { Image } from "antd";
import { LogoStyled } from "./styles";
import VeloPrimeBlack from "../../assets/veloprime/LOGO - VELOPRIME - PRETA.png";
import VeloPrimeWhite from "../../assets/veloprime/logo-veloprime-horizontal-white.png";
import VeloprimeIcon from "../../assets/veloprime/icons/icon-veloprime-white.png";
import VeloPrimeApp from "../../assets/veloprime/LOGO APLICAÇÃO - VELOPRIME.png";
import { isMobile } from "../../utils";

interface LogoProps {
  className?: string;
  src?: string;
  ext?: boolean;
  pblic?: boolean;
  variant?: 'black' | 'white' | 'app' | 'icon';
}

export const Logo: React.FC<LogoProps> = ({ src, className, ext, pblic, variant = 'black' }) => {
  const getLogoSrc = () => {
    if (src) return src;
    
    // Lógica para ext: quando true usa VeloPrimeWhite, quando false usa VeloprimeIcon
    if (ext === true) return VeloPrimeWhite;
    if (ext === false) return VeloprimeIcon;
    
    // Fallback para variant quando ext não é fornecido
    if (variant === 'white') return VeloPrimeWhite;
    if (variant === 'app') return VeloPrimeApp;
    if (variant === 'icon') return VeloprimeIcon;
    return VeloPrimeBlack;
  };

  return (
    <LogoStyled className={className}>
      <a href="https://veloprime.com.br/" target="_blank" rel="noreferrer">
        <Image
          preview={false}
          alt="VeloPrime logo"
          src={getLogoSrc()} 

        />
      </a>
    </LogoStyled>
  );
};
